{
  "version": "2026-10-30-draft-3",
  "status": "draft",
  "operator": "SOUTA SURYA PRAKASH",
  "brand": "Qronus",
  "supportEmail": "support@qronus.in",
  "effectiveDate": null,
  "contactAddress": null,
  "policies": [
    {
      "slug": "privacy",
      "title": "Privacy Policy",
      "status": "published",
      "version": "2026-10-29",
      "source": "Termly",
      "lastUpdated": "2026-10-29"
    },
    {
      "slug": "terms",
      "title": "Terms and Conditions",
      "status": "published",
      "version": "2026-10-30",
      "source": "Termly",
      "lastUpdated": "2026-10-30"
    },
    {
      "slug": "refunds",
      "title": "Cancellation and Refund Policy",
      "sections": [
        [
          "Scope and status",
          "These proposed rules cover Qronus platform memberships and paid-group memberships purchased through Qronus. They are not yet effective. The proposed refund windows and processing commitments require operational and technical implementation. Applicable statutory rights are not limited by this draft."
        ],
        [
          "Cancellation",
          "Users may request cancellation at any time through membership controls or support. Confirmed cancellation stops future renewals while access continues until the paid billing period ends. If billing has not started, cancellation may be immediate. There is no cancellation fee. Cancelling one membership does not cancel other memberships."
        ],
        [
          "First purchases",
          "Proposed rule: a full refund requested within seven days of the first purchase of a distinct membership, once per user for that membership. Cancelling and repurchasing the same membership does not create another first-purchase entitlement."
        ],
        [
          "Unintended renewals",
          "Proposed rule: refund a renewal requested within 48 hours of the charge if the renewed service has not been used. Accessing cancellation or support controls alone does not count as use."
        ],
        [
          "Payment and service problems",
          "Verified duplicate charges are refundable. If a captured payment does not provide access, restore access promptly or refund if the issue cannot be resolved. If a group closes during a paid cycle, refund the unused portion proportionally. Material differences from advertised services warrant review for an appropriate remedy."
        ],
        [
          "Other cancellations",
          "Outside these circumstances, a change of mind would not ordinarily qualify for a prorated refund. Refunds and other remedies required by applicable law remain available."
        ],
        [
          "Requests and processing",
          "Requests should include account email, membership name, payment reference and reason. Never send passwords, CVV, UPI PINs or complete card details. The proposed commitment is to initiate approved refunds within five business days to the original payment method. Bank or provider processing determines when the credit arrives."
        ],
        [
          "Access and owner payouts",
          "Under the proposed policy, a full membership refund ends access associated with that purchase and stops future renewals. Partial refunds must state their effect on access and billing. Qronus handles refund requests for payments it collects; approved refunds must not depend on an owner's voluntary return of an earlier payout."
        ]
      ]
    }
  ]
}
